<template>
  <Modal
    :modal="modal"
    title="Condição de Pagamento"
    cardBodyClass="pa-0"
    @close="$emit('close')"
    @save="save"
    @refresh="getCondicoesPagamentoAPI"
    @search="searchBox = !searchBox"
    :loading="loading"
    :fullscreen="true"
    :titleIcons="titleIcons"
  >
    <ListCondicoesPagamentoSelect
      :searchBox="searchBox"
      @condicaoPagamentoSelected="condicaoPagamentoSelected = $event"
    />
  </Modal>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import Modal from '@/components/shared/Modal';
import ListCondicoesPagamentoSelect from '@/components/condicoesPagamento/ListCondicoesPagamentoSelect';

export default {
  name: 'ModalCondicaoPagamento',
  props: {
    modal: {
      type: Boolean,
      default: false
    },
  },
  components: {
    Modal,
    ListCondicoesPagamentoSelect
  },
  data: () => ({
    loading: false,
    searchBox: false,
    condicaoPagamentoSelected: null,
  }),
  computed: {
    ...mapGetters(['condicoesPagamento']),
    titleIcons() {
      return [
        { name: 'mdi-refresh', event: 'refresh', loading: true },
        { name: this.searchBox ? 'mdi-close' : 'mdi-magnify', event: 'search', loading: false },
      ]
    }
  },
  methods: {
    ...mapMutations(['SHOW_SNACKBAR']),
    ...mapActions(['fetchCondicoesPagamento', 'fetchCondicoesPagamentoAPI']),
    condicaoPagamentoJaSelecionada(id_condicoes_pagamento) {
      return this.condicaoPagamentoSelected && this.condicaoPagamentoSelected.id_condicoes_pagamento == id_condicoes_pagamento;
    },
    getCondicoesPagamento() {
      this.loading = true;
        this.fetchCondicoesPagamento()
          .then(() => this.loading = false);
    },
    getCondicoesPagamentoAPI() {
      this.loading = true;
        this.fetchCondicoesPagamentoAPI()
          .then(() => {
            this.condicaoPagamentoSelected = null;
            this.loading = false;
          });
    },
    save() {
      if (this.condicaoPagamentoSelected) {
        this.$emit('save', this.condicaoPagamentoSelected);
      } else {
        this.SHOW_SNACKBAR({ text: 'Selecione a condição de pagamento!', status: 'error' });
      }
    }
  },
  watch: {
    modal(value) {
      if (value && !this.condicoesPagamento.length && !this.loading) {
        this.getCondicoesPagamento();
      }
    }
  },
}
</script>